/**
 * VendorProductVariantCategoryService
 * Service for managing vendor product variant categories with view endpoints
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for vendor product variant category CRUD operations with view endpoints
 */
export class VendorProductVariantCategoryService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? VendorProductVariantCategoryService.DEFAULT_SERVICE_PATH,
            basePath: VendorProductVariantCategoryService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all variant category views
     */
    async getViews() {
        const response = await this.getViewsRaw();
        return response.data ?? [];
    }
    getViewsRaw() {
        const url = this.buildUrl('views');
        return this.http.get(url);
    }
    /**
     * Get variant category view by ID
     */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data) {
            throw new Error(`Vendor product variant category view with ID ${id} not found`);
        }
        return response.data;
    }
    getViewRaw(id) {
        const url = this.buildUrl(`${id}/view`);
        return this.http.get(url);
    }
}
VendorProductVariantCategoryService.DEFAULT_SERVICE_PATH = 'vendor-catalogs';
VendorProductVariantCategoryService.BASE_PATH = 'api/vendor-product-variant-categories';
//# sourceMappingURL=VendorProductVariantCategoryService.js.map